<template>
  <tm-router-reloader-link
    :to="route!"
    :disabled="disabled"
    active-class="active-link"
    class="emphasize--text"
    :class="['page-content-sidebar-list-link', { 'active-link': overrideActive === true }]"
    tabindex="-1"
  >
    <page-content-sidebar-list-simple
      v-bind="$attrs"
      :title="title"
      :icon="icon"
      :badge="badge"
      :number="number"
      :number-limit="numberLimit"
      :disabled="disabled"
      :is-loading-number="isLoadingNumber"
      :highlight-exact-active="highlightExactActive"
      :right-icon="rightIcon"
      :in-group="inGroup"
      @lock-sidebar="$emit('lock-sidebar', $event)"
    >
      <template v-slot:icon>
        <slot name="icon" />
      </template>
      <template v-slot:append>
        <slot name="append" />
      </template>
      <template v-slot:after-link-content>
        <slot name="after-link-content" />
      </template>
    </page-content-sidebar-list-simple>
  </tm-router-reloader-link>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import PageContentSidebarListSimple from '@/components/layout/pageContent/sidebar/sidebarItem/PageContentSidebarListSimple.vue'
import TmRouterReloaderLink from '@/components/shared/TmRouterReloaderLink.vue'
import type { PageContentSidebarLink } from '@/components/layout/pageContent/sidebar/types'
import type { IconName } from '@/assets/icons/icons'

defineProps<{
  title: string
  route?: RouteLocationRaw
  icon?: IconName
  number?: number
  numberLimit?: number
  isLoadingNumber?: boolean
  badge?: PageContentSidebarLink['badge']
  rightIcon?: PageContentSidebarLink['rightIcon']
  highlightExactActive?: boolean
  disabled?: boolean
  overrideActive?: boolean
  inGroup?: boolean
}>()

defineOptions({ inheritAttrs: false })

defineEmits<{
  'lock-sidebar': [boolean]
}>()
</script>
